import React from 'react';
import { Box } from '@mui/material';
import { PageIndices, SectionIndices } from '../../common/i-doc/i-doc.registry.ts';
import { DashboardLayout } from '@components/DashboardLayout.tsx';
import { PageHint } from '@components/common/PageHint';
import { ClientAppointmentsList } from '../../components/appointments/client/ClientAppointmentsList';

const ClientAppointmentsPage: React.FC = () => {
  return (
    <DashboardLayout>
      <Box data-i-doc={PageIndices.CLIENT_APPOINTMENTS}>
        <PageHint iDoc={PageIndices.CLIENT_APPOINTMENTS} />
        <Box data-i-doc={SectionIndices.CLIENT_APPOINTMENTS_LIST}>
          <PageHint iDoc={SectionIndices.CLIENT_APPOINTMENTS_LIST} />
          <ClientAppointmentsList />
        </Box>
      </Box>
    </DashboardLayout>
  );
};

export default ClientAppointmentsPage;
